import store from "@/store/index";

export default (to, from, next) => {
  if (store.getters["auth/isGuest"]) {
    next();
  } else {
    next({ name: "dashboard" });
  }
};
